
(function ($) {

  function ready() {
    var displayAD = $('.help-display-ad');
    if (displayAD.length > 0) {
      if (ux.traffic && ux.traffic.impression) {
        ux.traffic.impression('mcx.help.display-ad.impression');
      }
    }
  }

  $(document).ready(ready);

}(jQuery));
